<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'LABEL.vehicleInspChecklist' | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="wrapper">

  <!-- START INSPECTION -->
  @if (state === 'inspection') {
    @if (features.inspection.nonCriticalOptional) {
      <p class="instructions">{{ 'VALIDATION.criticalItems1' | translate }}<strong class="critical">*</strong>{{ 'VALIDATION.criticalItems2' | translate }}</p>
    }
    @for (inspectionGroup of inspectionGroups; track inspectionGroup) {
      <ion-card class="group">
        @if (inspectionGroup.serviceCategory) {
          <ion-card-header>
            <ion-card-title>{{ inspectionGroup.serviceCategory }}</ion-card-title>
          </ion-card-header>
        }
        <ion-card-content>
          @for (inspection of inspectionGroup.inspectionItems; track inspection) {
            <section>
              <h2>
                @if (features.inspection.nonCriticalOptional && inspection.isCritical) {
                  <strong class="critical">*</strong>
                }
                {{ inspection.description  }}
              </h2>
              @if (inspection.questionType === 0) {
                <ion-segment
                  mode="ios"
                  (ionChange)="inspectionValueClicked($event, inspection)"
                  [value]="inspection.result"
                  >
                  <ng-container *ngTemplateOutlet="features.inspection.alternateResultValues ? AlternateInspectionButtons : DefaultInspectionButtons" />
                </ion-segment>
              }
              <ng-template #DefaultInspectionButtons>
                <ion-segment-button
                  color="success"
                  class="segment-ok"
                  [value]="InspectionResultEnum.Pass"
                  >
                  <ion-label>{{ 'ACTION.ok' | translate}} </ion-label>
                </ion-segment-button>
                <ion-segment-button
                  color="warning"
                  class="segment-service-needed"
                  [value]="InspectionResultEnum.ServiceDueSoon"
                  >
                  <ion-label>
                    <span class="hidden-insp">{{ 'ACTION.serviceDueSoon' | translate }}</span>
                    <span class="show-insp">{{ 'ACTION.serviceDueSoonDue' | translate }}</span>
                  </ion-label>
                </ion-segment-button>
                <ion-segment-button
                  color="danger"
                  class="segment-service-critical"
                  [value]="InspectionResultEnum.ServiceCritical"
                  >
                  <ion-label>
                    <span class="hidden-insp">
                      {{ 'ACTION.serviceCritical' | translate }}
                    </span>
                    <span class="show-insp">
                      {{ 'ACTION.serviceCriticalCritical' | translate }}
                    </span>
                  </ion-label>
                </ion-segment-button>
              </ng-template>
              <ng-template #AlternateInspectionButtons>
                <ion-segment-button
                  color="success"
                  class="segment-ok"
                  [value]="InspectionResultEnum.Pass"
                  >
                  <ion-label>{{ 'ACTION.ok' | translate}} </ion-label>
                </ion-segment-button>
                <ion-segment-button
                  color="danger"
                  [ngClass]="inspection.isCritical ? 'segment-service-critical' : 'segment-service-needed'"
                  [value]="InspectionResultEnum.ServiceDueSoon"
                  >
                  <ion-label>
                    <span>{{ 'ACTION.fail' | translate }}</span>
                  </ion-label>
                </ion-segment-button>
              </ng-template>
              @if (inspection.questionType == 1) {
                <ion-item fill="outline">
                  <ion-input
                    [label]="inspection.description"
                    labelPlacement="stacked"
                    type="text"
                    inputmode="text"
                    minlength="1"
                    (ionInput)="inspectionValueChanged(inspection, $event.target.value)"
                    [placeholder]="'PLACEHOLDER.enterValue' | translate"
                    [value]="inspection.textResult"
                    required>
                  </ion-input>
                </ion-item>
              }
              @if (features.inspection.useComment) {
                <ion-item>
                  <ion-input
                    [label]="'LABEL.comment' | translate"
                    labelPlacement="stacked"
                    type="text"
                    inputmode="text"
                    maxlength="280"
                    (ionInput)="inspectionCommentChanged(inspection, $event.target.value)"
                    [placeholder]="'PLACEHOLDER.enterValue' | translate"
                    [value]="inspection.comment">
                  </ion-input>
                </ion-item>
              }
            </section>
          }
        </ion-card-content>
      </ion-card>
    }
  }
  <!-- END START INSPECTION -->

  <!-- CRITICAL CONFIRMATION -->

  @if (state === 'criticalWarning') {
    <div class="warning">
      <ion-row>
        <ion-col>
          <h3>{{ 'TITLE.criticalFailures' | translate }}</h3>
        </ion-col>
      </ion-row>
      <ion-list>
        @for (failure of getFailures(); track failure) {
          <ion-item>
            <ion-label>{{ failure.description }}</ion-label>
          </ion-item>
        }
      </ion-list>
    </div>
  }

</ion-content>

<ion-footer>
  @if (features.inspection.nonCriticalOptional) {
    <ion-row>
      <ion-col class="progress">
        {{ 'LABEL.inspected' | translate }} {{ itemsComplete }} / {{ inspectionItems.length }} ({{ criticalItemsLeft }} {{ 'LABEL.mandatoryRemaining' | translate }})
      </ion-col>
    </ion-row>
  }
  @if (state === 'inspection') {
    <ion-row>
      @if (data.route.inspectionBypassEnabled ?? false) {
        <ion-col>
          <ion-button
            type="button"
            color="primary"
            fill="outline"
            expand="block"
            (click)="bypassInspection()"
            >
            {{  'ACTION.bypass' | translate }}
            <ion-icon name="arrow-redo-outline" slot="end" />
          </ion-button>
        </ion-col>
      }
      <ion-col>
        <ion-button
          type="button"
          color="primary"
          expand="block"
          (click)="submitInspection()"
          [disabled]="!canSubmit"
          >
          {{  'ACTION.submit' | translate }}
          <ion-icon name="checkmark" slot="end" />
        </ion-button>
      </ion-col>
    </ion-row>
  }

  @if (state === 'criticalWarning') {
    <ion-row>
      <ion-col>
        <ion-button
          type="button"
          color="medium"
          expand="block"
          (click)="cancelCriticalWarning()"
          [disabled]="!canSubmit"
          >
          {{  'ACTION.cancel' | translate }}
          <ion-icon name="close-outline" slot="end"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col>
        <ion-button
          type="button"
          color="danger"
          expand="block"
          (click)="submit(true)"
          [disabled]="!canSubmit"
          >
          {{  'ACTION.confirm' | translate }}
          <ion-icon name="checkmark" slot="end"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  }
</ion-footer>
